/**
 * Hide specified elements and show the specified element.
 *
 * @param {string} classElemsToHide - The CSS selector for the elements to hide.
 * @param {string} classElemToShow - The CSS selector for the element to show.
 */
// function mmMegaMenuShowProducts(classElemsToHide, classElemToShow) {
//     var imageContainers = document.querySelectorAll(classElemsToHide);
//     imageContainers.forEach(function(imageContainer) {
//         imageContainer.style.display = 'none';
//     });
//     document.querySelector(classElemToShow).style.display = 'grid';
// }

/*
  Header hover link changer opacity to others links
*/
function changeOpacityHeaderLinks() {
  const headerLinks = document.querySelectorAll(".mm-header-menu-link");
  headerLinks.forEach( link => {
    link.addEventListener("mouseover", () => {
      headerLinks.forEach((otherLink) => {
        if (otherLink !== link) {
          otherLink.classList.add("inactive"); // Ajouter la classe
        }
      });
    });
    link.addEventListener("mouseout", () => {
      headerLinks.forEach((otherLink) => {
        if (otherLink !== link) {
          otherLink.classList.remove("inactive"); // Retirer la classe
        }
      });
    });
  });
}

/*
  Mobile scroll show header center links
*/
function showHeaderCenterScroll(){
  let lastScrollTop = 0;
  const header = document.querySelector(".mm-header-center-mobile");

  window.addEventListener("scroll", () => {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop > lastScrollTop) {
			// Scrolling down
			header.style.transform = "translateY(-100%)";
		} else {
			// Scrolling up
			header.style.transform = "translateY(0)";
		}

		lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  });
}
/**
 * Adjust the position of the mega menu based on the header height.
 */
// function getMegaMenuPosition() {
//     var menuElems = document.querySelectorAll('.mm-header-link');
//     var header = document.querySelector('.mm-section-header');
//     var headerHeight = header.offsetHeight;

//     menuElems.forEach(function(menuElem) {
//         if (menuElem.nextElementSibling) {
//             if (menuElem.nextElementSibling.classList.contains('mm-mega-menu-wrapper') || menuElem.nextElementSibling.classList.contains('mm-header-submenu')) {
//                 menuElem.nextElementSibling.style.top = `${headerHeight}px`;
//             }
//         }
//     });
// }

/**
 * Add background filter on hover over mega menu links.
 */
// function hoverBgFilter() {
//     const header = document.querySelector('.mm-header');
//     const megaMenuLinks = document.querySelectorAll('.mm-header-link-mega-menu');
//     const filter = document.querySelector('.mm-filter-mega-menu');

//     megaMenuLinks.forEach(megaMenuLink => {
//         megaMenuLink.addEventListener('mouseenter', () => {
//             filter.classList.add("active");
//         });
//         header.addEventListener('mouseleave', () => {
//             filter.classList.remove("active");
//         });
//     });
// }

/**
 * Show background filter.
 */
function showBgFilter() {
    const filter = document.querySelector('.mm-filter-mega-menu');
    filter.style.zIndex = 'var(--index)';
    filter.classList.add("active");
}

/**
 * Hide background filter.
 */
function hideBgFilter() {
    const filter = document.querySelector('.mm-filter-mega-menu');
    filter.style.removeProperty('z-index');
    filter.classList.remove("active");
}

/**
 * Open external links in a new tab unless it's the consent modale.
 */
function externalLink() {
	var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
        if (!links[i].classList.contains('consent-wrapper') && links[i].hostname !== window.location.hostname) {
            links[i].target = '_blank';
            links[i].rel = 'noreferrer noopener';
        }
    }
}

/**
 * Toggle the mobile menu.
 */
function mmMobileMenu() {
    if (window.innerWidth <= 768) {
        const header = document.querySelector("header");
        const icon = header.querySelector(".mm-header-burger");
        const mobileMenu = header.querySelector(".mm-mobile-menu-wrapper");
        let headerMenu = header.querySelector('.mm-header');
        let headerHeight = headerMenu.offsetHeight;
        let headerMenuTop = headerMenu.getBoundingClientRect().top;

        header.classList.toggle("mm-open");
        icon.classList.toggle("mm-open");
        mobileMenu.classList.toggle("mm-menu-open");
        document.querySelector("html").classList.toggle("stop-scrolling");

        mobileMenu.style.top = `calc(${headerHeight}px + ${headerMenuTop}px)`;
        mobileMenu.style.height = `calc(100dvh - (${headerHeight}px + ${headerMenuTop}px))`;
    }
}

/**
 * Close the mobile menu.
 */
function mmCloseMobileMenu() {
    if (window.innerWidth <= 768) {
        const header = document.querySelector("header");
        const icon = document.querySelector(".mm-header-burger");
        const mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");

        header.classList.remove("mm-open");
        icon.classList.remove("mm-open");
        document.querySelector("html").classList.toggle("stop-scrolling");
        mobileMenu.classList.remove("mm-menu-open");
        hideBgFilter();
    }
}

/**
 * Show the next sub-menu in the mobile menu.
 *
 * @param {string} elemToShowClass - The CSS selector of the element to show.
 */
function mmMobileMenuShowNext(elemToShowClass) {
    var elemToShow = document.querySelector(elemToShowClass);
    elemToShow.classList.add('mm-mobile-menu-elem-slided');
}

/**
 * Show the previous sub-menu in the mobile menu.
 *
 * @param {string} elemToShowClass - The CSS selector of the element to show.
 */
function mmMobileMenuShowPrev(elemToShowClass) {
    var elemToShow = document.querySelector(elemToShowClass);
    elemToShow.classList.remove('mm-mobile-menu-elem-slided');
}

/**
 * Handle dropdown behavior.
 */
function handleDropdown() {
    const dropWrapper = document.querySelectorAll('.mm-drop-wrapper');

    // Open the first dropdown by default
    if (dropWrapper.length > 0) {
        dropWrapper[0].classList.add('active');
        dropWrapper[0].nextElementSibling.style.maxHeight = dropWrapper[0].nextElementSibling.scrollHeight + 'px';
    }

    dropWrapper.forEach((item) => {
        item.addEventListener('click', function () {
            // Close all other dropdowns
            dropWrapper.forEach((el) => {
                if (el !== this) {
                    el.classList.remove('active');
                    el.nextElementSibling.style.maxHeight = null;
                }
            });

            // Toggle the current dropdown
            this.classList.toggle('active');

            const content = this.nextElementSibling;

            if (this.classList.contains('active')) {
                content.style.maxHeight = content.scrollHeight + "px";
			} else {
				content.style.maxHeight = "0px";
			}
        });
    });
}

/**
 * Set the document height CSS variable to the current window height.
 */
const documentHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--doc-height', `${window.innerHeight}px`);
}

// Custom element for product recommendations
class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
                .then((response) => response.text())
                .then((text) => {
                    const html = document.createElement("div");
                    html.innerHTML = text;
                    const recommendations = html.querySelector("product-recommendations");

                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                    }

                })
                .catch((e) => {
                    console.error(e);
                });
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
    }
}

customElements.define("product-recommendations", ProductRecommendations);

document.addEventListener("DOMContentLoaded", (event) => {
  changeOpacityHeaderLinks();
  handleDropdown();
	externalLink();

  if (window.innerWidth <= 990) {
		showHeaderCenterScroll();
  }
});

window.addEventListener('resize', documentHeight);
documentHeight();


/* MM selected products SPLIDE */
function initSplidesSelectedProducts() {
  var splides = document.querySelectorAll(".mm-selected-products-splide");

  if (splides) {
    splides.forEach(splide => {
      let bar = splide.querySelector(".my-carousel-progress-bar");
      let arrowsContainer = splide.closest(".mm-section").querySelector(".mm-splide-arrows");
      let arrowPrev = arrowsContainer.querySelector(".mm-arrow-prev");
      let arrowNext = arrowsContainer.querySelector(".mm-arrow-next");

      let newSplide = new Splide(splide, {
        type: "slide",
        arrows: false,
        pagination: false,
        gap: 80,
        perPage: 3,
        breakpoints: {
          1200: {
            gap: 40,
          },
          1000: {
            perPage: 2,
            arrows: false,
            gap: 16
          },
          700: {
            perPage: 1,
            padding: {
              right: '10%',
            }
          }
        },
      }).mount();

      if (bar) {
        newSplide.on("mounted move", function () {
          var end = newSplide.Components.Controller.getEnd() + 1;
          var rate = Math.min((newSplide.index + 1) / end, 1);
          bar.style.width = String(100 * rate) + "%";
        });
		  }

      if (arrowsContainer) {
        arrowNext.addEventListener("click", function(){
            newSplide.go( '+1' );
          });
        arrowPrev.addEventListener("click", function(){
            newSplide.go( '-1' );
          });
      }
    });
  }
}
document.addEventListener("DOMContentLoaded", function () {
  initSplidesSelectedProducts();
});

/* MM selected products SPLIDE petites cards */
function initSplidesSelectedProductsLittle() {
  var splides = document.querySelectorAll(".mm-selected-products-splide-little");
  if (splides) {
    splides.forEach(splide => {
      var bar = splide.querySelector(".my-carousel-progress-bar");
      let arrowsContainer = splide.closest(".mm-section").querySelector(".mm-splide-arrows");
      let arrowPrev = arrowsContainer.querySelector(".mm-arrow-prev");
      let arrowNext = arrowsContainer.querySelector(".mm-arrow-next");
      let newSplide = new Splide(splide, {
        type: "slide",
        arrows: false,
        pagination: false,
        gap: 20,
        perPage: 6,
        breakpoints: {
          1000: {
            perPage: 2,
            arrows: false,
          },
          700: {
            perPage: 1,
            padding: {
              right: '20%',
            }
          }
        },
      }).mount();

      if (bar) {
        newSplide.on("mounted move", function () {
          var end = newSplide.Components.Controller.getEnd() + 1;
          var rate = Math.min((newSplide.index + 1) / end, 1);
          bar.style.width = String(100 * rate) + "%";
        });
		  }

      if (arrowsContainer) {
        arrowNext.addEventListener("click", function () {
          newSplide.go("+1");
        });
        arrowPrev.addEventListener("click", function () {
          newSplide.go("-1");
        });
      }
    });
  }
}
document.addEventListener("DOMContentLoaded", function () {
  initSplidesSelectedProductsLittle();
});

/* Articles SPLIDE*/

function initSplideArticles() {
  var splides = document.querySelectorAll(".mm-articles-splide");
  console.log(splides);
  if (splides) {
    splides.forEach(splide => {
      var bar = splide.querySelector(".my-carousel-progress-bar");
      let newSplide = new Splide(splide, {
        type: "slide",
        arrows: false,
        pagination: false,
        gap: 20,
        perPage: 3,
        breakpoints: {
          1000: {
            perPage: 2,
            arrows: true,
          },
          768: {
            perPage: 1,
            padding: {
              right: '18%',
            }
          }
        },
      }).mount();

      newSplide.on("mounted move", function () {
        var end = newSplide.Components.Controller.getEnd() + 1;
        var rate = Math.min((newSplide.index + 1) / end, 1);
        bar.style.width = String(100 * rate) + "%";
      });
    });
  }
}
document.addEventListener("DOMContentLoaded", function () {
	initSplideArticles();
});


// Announcement bar splide //

document.addEventListener( "DOMContentLoaded", function() {
	var id = '.splide-announcement-bar';
	var splideElem = document.querySelector(id);

	new Splide( splideElem, {
		type: 'slide',
		mediaQuery: 'min',
		autoplay: true,
		rewind: true,
		arrows: false,
		pagination: false,
		perPage: 1,
		gap: 8,
		width: '215px',
		breakpoints: {
			1070: {
				destroy: true,
			}
		}
	}).mount();

});

/*---------- ANIMATIONS ----------*/

//scrollTrigger plugin registration
gsap.registerPlugin(ScrollTrigger);

const fadeInElements = document.querySelectorAll('[data-animate-fade]');
fadeInElements.forEach(elem => {
  gsap.from(elem, {
    opacity: 0,
    y:50,
    duration: 1,
    scrollTrigger: {
      trigger: elem,
      start: "top 80%",
      end: "bottom 20%",
      toggleActions: "play none none none"
    }
  });
  gsap.to(elem, {
    stagger: 0.2
  });
});

const lines = document.querySelectorAll('[data-animate-line]');
lines.forEach(elem => {
  gsap.from(elem, {
    scaleX: 0,
    delay:0.2,
    duration: 1,
    scrollTrigger: {
      trigger: elem,
      start: "top 80%",
      end: "bottom 20%",
      toggleActions: "play none none none"
    }
  });
  gsap.to(elem, {
    stagger: 0.2
  });
});

/* BTN Primary */
const DURATION = 500;
let isAnimating = false;

const ctaPrimary = document.querySelectorAll(".mm-btn-primary");
ctaPrimary.forEach((cta) => {
	// Define SVG paths and colors outside of the burst to optimize performance
	const svgNS = "http://www.w3.org/2000/svg";
	const paths = ["M5.55487 2.48552C3.16589 3.82666 1.24388 6.61998 0.57663 9.43418C0.496422 9.28861 0.43275 9.13453 0.386802 8.9748C0.201719 7.93075 0.349786 6.90093 0.628833 5.88914C1.19832 3.82096 2.66189 2.54532 4.49373 1.62465C6.04113 0.864613 7.76139 0.525472 9.48147 0.641341C9.79278 0.657477 9.86777 0.765678 9.72824 1.04378C9.02303 2.44851 8.58927 3.9453 8.18019 5.45538C7.57654 7.64316 6.15568 9.10009 3.95842 9.74456C3.41801 9.91047 2.86264 10.023 2.30027 10.0805C1.79343 10.1261 1.49065 10.3852 1.22394 10.7649C1.15865 10.8733 1.07056 10.9663 0.965778 11.0373C1.36537 7.57861 2.80047 4.68089 5.55487 2.48552Z", "M5.55487 2.48552C3.16589 3.82666 1.24388 6.61998 0.57663 9.43418C0.496422 9.28861 0.43275 9.13453 0.386802 8.9748C0.201719 7.93075 0.349786 6.90093 0.628833 5.88914C1.19832 3.82096 2.66189 2.54532 4.49373 1.62465C6.04113 0.864613 7.76139 0.525472 9.48147 0.641341C9.79278 0.657477 9.86777 0.765678 9.72824 1.04378C9.02303 2.44851 8.58927 3.9453 8.18019 5.45538C7.57654 7.64316 6.15568 9.10009 3.95842 9.74456C3.41801 9.91047 2.86264 10.023 2.30027 10.0805C1.79343 10.1261 1.49065 10.3852 1.22394 10.7649C1.15865 10.8733 1.07056 10.9663 0.965778 11.0373C1.36537 7.57861 2.80047 4.68089 5.55487 2.48552Z", "M6.97384 4.99296C6.11202 3.49047 4.95407 2.36669 3.40128 1.67097C3.19239 1.57899 2.96481 1.53737 2.73688 1.54948C3.19247 1.84276 3.65565 2.12751 4.10554 2.43123C5.25495 3.20763 5.9763 4.31813 6.51351 5.5634C6.6369 5.84814 6.5866 6.01898 6.22877 6.10061C4.65699 6.45749 3.36806 5.92217 2.20821 4.91228C1.40903 4.21561 0.943005 3.31393 0.58423 2.33632C0.438063 1.93198 0.27576 1.5248 0.124847 1.12996C0.0489155 0.918299 0.0659999 0.755993 0.341251 0.723722C2.07058 0.478843 3.71734 0.663929 5.18946 1.68236C6.27433 2.43218 6.81344 3.5199 7.00232 4.80314C7.00071 4.86735 6.99114 4.93111 6.97384 4.99296Z"];
	const colors = ["#DD5F5F", "#0A7B57", "#0EA574"];

	const burst = new mojs.Burst({
		left: 0,
		top: 0,
		degree: 0,
		count: 3,
		radius: {0: 100},
		children: {
			shape: "circle",
			fill: "transparent",
			duration: `rand(${1 * DURATION}, ${2 * DURATION})`,
			delay: "rand(0, 75)",
			easing: "quad.out",
			isSwirl: true,
			isForce3d: true,
			pathScale: "rand(0.5, 1)",
			radius: "rand(12, 15)",
			swirlSize: "rand(10, 15)",
			swirlFrequency: "rand(3, 7)",
			direction: [1, -1],
			angle: {0: "rand(60, 220)"}, // Adding random rotation
			onStart: function () {
				const index = Math.floor(Math.random() * paths.length);

				const svg = document.createElementNS(svgNS, "svg");
				svg.setAttribute("width", "10");
				svg.setAttribute("height", "12");
				svg.setAttribute("viewBox", "0 0 10 12");
				svg.setAttribute("fill", "none");
        svg.setAttribute("pointer-events", "none");

				const path = document.createElementNS(svgNS, "path");
				path.setAttribute("d", paths[index]);
				path.setAttribute("fill", colors[index]);

				svg.appendChild(path);
				svg.classList.add("animated-svg");
				this.el.appendChild(svg);
			},
			onComplete: function () {
				this.el.innerHTML = "";
				isAnimating = false;
			},
		},
	});

	cta.addEventListener("mouseover", (e) => {
		if (!isAnimating) {
			burst.tune({x: e.pageX, y: e.pageY}).generate().replay();
			isAnimating = true;
		}
	});

	cta.addEventListener("click", (e) => {
		if (!isAnimating) {
			burst.tune({x: e.pageX, y: e.pageY}).generate().replay();
			isAnimating = true;
		}
	});
});

// Loader
function mmLoadThis(button) {
  button.classList.add('mm-loading')
}
